// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + (chunkId === 347 ? "secondary" : chunkId) + "." + {"173":"f94bec3b83891e475fd2","347":"bf955cdb5816c8921d1b","724":"926e1111f82761d6d12e"}[chunkId] + ".js";
};